import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RouteName } from '@mews-commander/enums';
import {
    initializeProductServiceOrderCreatePage,
    ProductServiceOrderCreatePage,
} from '@mews-commander/modules/src/modules/productServiceOrder';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/ProductServiceOrder/Create')({
    validateSearch: z.object({
        OwnerId: z.string().uuid(),
        ServiceId: z.string().uuid().optional(),
        billId: z.string().uuid().optional(),
        GuestIds: z
            .string()
            .uuid()
            .transform((x) => [x])
            .or(z.array(z.string().uuid()))
            .optional(),
        AllowNegativeValues: z
            .string()
            .optional()
            .transform((value) => value === 'true' || value === undefined),
        OnlyOfferedToEmployee: z
            .string()
            .optional()
            .transform((value) => value === 'true'),
    }),
    loaderDeps: ({ search: { ServiceId, OwnerId, GuestIds } }) => ({ ServiceId, OwnerId, GuestIds }),
    loader: async ({
        deps: { ServiceId, OwnerId, GuestIds },
        context: { dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: dispatch },
    }) => {
        const search = { ServiceId, OwnerId, GuestIds };
        await initializeProductServiceOrderCreatePage({ search, dispatch });
    },
    component: Component,
    staticData: {
        routeName: RouteName.ProductServiceOrderCreate,
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
    },
});

function Component() {
    const { billId, OwnerId, ServiceId, GuestIds, AllowNegativeValues, OnlyOfferedToEmployee } = Route.useSearch();

    return (
        <ProductServiceOrderCreatePage
            billId={billId}
            customerId={OwnerId}
            serviceId={ServiceId}
            guestIds={GuestIds}
            allowNegativeValues={AllowNegativeValues}
            onlyOfferedToEmployee={OnlyOfferedToEmployee}
        />
    );
}
